export class SessionRestoreError extends Error {
  override cause: Error | undefined = undefined;

  constructor(options: { cause?: Error } = {}) {
    super(undefined);
    this.cause = options.cause;
  }
}
